import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import {
    PLACEHOLDER_LOADER_HEIGHT,
    PLACEHOLDER_LOADER_WIDTH,
} from "app/pages/sales-intelligence/modules/enrichment/constants/constants";

import { StyledWrappedPreview, StyledIconWrapper } from "../../containers/EnrichmentCsvContainer/style";

import type { SummaryProps } from "./type";

export const CompanyEnrichmentSummary = ({
    isLoading,
    badge,
    infoTooltip,
    isOutOfQuota,
    summaryText,
}: SummaryProps) => {
    return (
        <StyledWrappedPreview
            isOutOfQuota={isOutOfQuota}
            className="preview-hint"
        >
            <Flex>
                {isLoading ? (
                    <PixelPlaceholderLoader
                        width={PLACEHOLDER_LOADER_WIDTH}
                        height={PLACEHOLDER_LOADER_HEIGHT}
                    />
                ) : (
                    <Box>{summaryText}</Box>
                )}

                <StyledIconWrapper>{infoTooltip}</StyledIconWrapper>
            </Flex>

            {badge}
        </StyledWrappedPreview>
    );
};
